import gql from 'graphql-tag';

const QUERY_REVIEWS = gql`
  query Reviews($reference: ID!) {
    reviews(reference: $reference) {
      reviews {
        id
        author
        publicationDate
        factors {
          type
          rating
        }
        text
        rating
        reply {
          text
          publicationDate
        }
      }
      average {
        type
        rating
      }
      totalAverage
    }
  }
`;

export const getReviewsQuery = client => reference =>
  client.query({
    query: QUERY_REVIEWS,
    fetchPolicy: 'network-only',
    variables: {
      reference
    }
  });

export default getReviewsQuery;
